import React from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { ICON_EDIT, ICON_REMOVE } from '../../extras/icons';
//Función principal
const AccusedInfoForm = props => {
    //Tomo los props
    const { accused, index, handleEdit, handleRemove } = props;
    //Renderizo
    return (
        <div className="col-12">
            <div className="card mb-2 border-info">
                <div className="card-header">
                    <strong>IMPUTADO #{ index + 1 }</strong>
                    {
                        handleRemove ? (
                            <Button variant="danger" size="sm" className="float-right ml-2" onClick={() => handleRemove(accused)}>
                                <ICON_REMOVE />
                            </Button>
                        ) : null
                    }
                    {
                        handleEdit ? (
                            <Button variant="info" size="sm" className="float-right ml-2" onClick={() => handleEdit(accused)}>
                                <ICON_EDIT />
                            </Button>
                        ) : null
                    }
                </div>
                <div className="card-body">
                    <div className="h6 mb-0 font-weight-bold text-gray-800">
                        <div className="row">
                            <div className="col-md-6 mb-1">
                                <small>APELLIDO Y NOMBRE:</small>
                                <br/>
                                { `${accused.persona.apellido}, ${accused.persona.nombre}` }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>TIPO Y NÚMERO DOC.:</small>
                                <br/>
                                { `${accused.persona.tipo_documento}: ${accused.persona.nro_documento}` }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>ES MENOR?:</small>
                                <br/>
                                { accused.menor === '1' ? 'SI' : 'NO' }
                            </div>
                            <div className="col-md-6 mb-1">
                                <small>DOMICILIO:</small>
                                <br/>
                                { accused.domicilio }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>TELÉFONO:</small>
                                <br/>
                                { accused.telefono }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>EMAIL:</small>
                                <br/>
                                { accused.email }
                            </div>
                            
                            <div className="col-md-6 mb-1">
                                <small>DEF. MENORES:</small>
                                <br/>
                                {
                                    accused.menores ? accused.menores.descripcion : 'N/D'
                                }
                            </div>
                            <div className="col-md-6 mb-1">
                                <small>DEFENSA PÚBLICA:</small>
                                <br/>
                                {
                                    accused.defensoria ? accused.defensoria.descripcion : 'N/D'
                                }
                            </div>
                            {
                                accused.particular && accused.particular.length > 0 ? (
                                    <div className="col-12 mb-1 mb-2">
                                        <table className="table table-bordered table-sm">
                                            <thead>
                                                <tr className="table-light">
                                                    <th colSpan="3" className="align-middle text-center">
                                                        DEFENSORES PARTICULARES
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">Apellido y Nombre</th>
                                                    <th className="text-center">Email</th>
                                                    <th className="text-center">Teléfono</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    accused.particular.map(p => (
                                                        <tr>
                                                            <td className="align-middle">
                                                                { p.persona.apellido + ', ' + p.persona.nombre }
                                                            </td>
                                                            <td className="align-middle text-center">
                                                                { p.email }
                                                            </td>
                                                            <td className="align-middletext-center">
                                                                { p.telefono }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                ) : null
                            }
                            <div className="col-md-2 mb-1">
                                <small>DETENIDO?:</small>
                                <br/>
                                { accused.detenido === '1' ? 'SI' : 'NO' }
                            </div>
                            {
                                accused.detenido === '1' ? (
                                    <React.Fragment>
                                        <div className="col-md-6 mb-1">
                                            <small>DEPENDENCIA:</small>
                                            <br/>
                                            { accused.dependencia ? accused.dependencia.descripcion : 'N/D' }
                                        </div>
                                        <div className="col-md-2 mb-1">
                                            <small>DETENCIÓN:</small>
                                            <br/>
                                            { accused.fecha_detencion ? moment(accused.fecha_detencion).format('DD/MM/YYYY HH:mm') : '' }
                                        </div>
                                        <div className="col-md-2 mb-1">
                                            <small>VENCIMIENTO:</small>
                                            <br/>
                                            { accused.fecha_vencimiento ? moment(accused.fecha_vencimiento).format('DD/MM/YYYY HH:mm') : '' }
                                        </div>
                                    </React.Fragment>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccusedInfoForm;